import { render, staticRenderFns } from "./OfficeAcquisition.vue?vue&type=template&id=37cfbcac"
import script from "./OfficeAcquisition.vue?vue&type=script&lang=ts"
export * from "./OfficeAcquisition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports